/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Type_FilterInputs */

const fr_network_vehicle_type_filter = /** @type {(inputs: Network_Vehicle_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const en_network_vehicle_type_filter = /** @type {(inputs: Network_Vehicle_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Network_Vehicle_Type_FilterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_type_filter = /** @type {((inputs?: Network_Vehicle_Type_FilterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Type_FilterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_type_filter(inputs)
	return en_network_vehicle_type_filter(inputs)
});